
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Business, { BusinessProxy } from '../models/Business';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import MediaImg from 'spa-ionata-admin/lib/components/MediaImg.vue';
import SectorAndCategroy from './SectorAndCategroy.vue';
import BusinessTestimony from './BusinessTestimony.vue';

@Component({
  components: {
    MediaImg,
    SectorAndCategroy,
    BusinessTestimony,
  },
})
export default class extends Vue {
  @Prop(String) readonly slug!: string;

  @Prop(Object) readonly business!: Business;

  hover = false;

  dataPromise = new ObservedPromise<BusinessProxy>();

  get item(): Business | undefined {
    return this.business || this.dataPromise.value?.data || undefined;
  }

  get url(): string {
    if (!this.item) {
      return '';
    }
    return `/business/${this.item.slug}`;
  }

  get elevation(): number {
    return this.hover ? 10 : 0;
  }

  get imageId() {
    return this.item?.quoteImage?.id;
  }

  get aspectRatio() {
    return this.item?.quoteAspectRatio;
  }

  @Watch('slug', { immediate: true })
  onSlugChanged(slug: string | undefined) {
    if (slug) {
      const promise = Business.where({ slug }).first();
      this.dataPromise = new ObservedPromise(promise);
    }
  }
}
